import { render, staticRenderFns } from "./TokenValidationModal.vue?vue&type=template&id=53c0b18c&"
import script from "./TokenValidationModal.vue?vue&type=script&lang=js&"
export * from "./TokenValidationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports